import React from "react";
import { Box, Link, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { TicketDevice } from "../types/supervisorType";
import { NEUTRAL, VIOLET } from "../styles/brandTokens";
import DeviceAlertHistory from "./DeviceAlertHistory";

export default function TicketDeviceProperties({ device }: { device?: TicketDevice | null }) {
  if (!device) return null;
  const path = `/devices/${encodeURIComponent(device.source_type)}/${encodeURIComponent(device.source_id)}/${encodeURIComponent(device.device_id)}`;
  const rows = [
    ["Hostname", device.host_name],
    ["RMM", device.provider === "datto" ? "Datto RMM" : "NinjaOne"],
    ["Operating system", device.operating_system],
    ["User", device.user],
    ["Status", device.online === true ? "Online" : device.online === false ? "Offline" : null],
  ];
  return (
    <Box>
      {rows.filter(([, value]) => Boolean(value)).map(([label, value]) => (
        <Box key={label} sx={{ display: "flex", alignItems: "flex-start", mb: 2, gap: 2 }}>
          <Typography sx={{ color: NEUTRAL.textMuted, fontSize: 12, fontWeight: 500, minWidth: 90 }}>{label}</Typography>
          <Typography sx={{ color: NEUTRAL.text, fontSize: 13, minWidth: 0, overflowWrap: "anywhere" }}>{value}</Typography>
        </Box>
      ))}
      <Link href={path} target="_blank" rel="noopener noreferrer" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, color: VIOLET.theoText, fontSize: 13 }}>
        Open in Theo <OpenInNewIcon sx={{ fontSize: 15 }} />
      </Link>
      <DeviceAlertHistory deviceName={device.host_name} identity={{ sourceType: device.source_type, sourceId: device.source_id, deviceId: device.device_id }} />
    </Box>
  );
}
